import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import { CustomCursor } from "@/components/CustomCursor";
import LandingPage from "@/pages/LandingPage";
import Admin from "@/pages/Admin";
import CityPage from "@/pages/CityPage";
import TrackPage from "@/pages/TrackPage";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import { CITIES } from "@/data/cities";

export default function App() {
  return (
    <LanguageProvider>
      <CustomCursor />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {CITIES.map((c) => (
            <Route key={c.slug} path={`/windshield-replacement-${c.slug}`} element={<CityPage slug={c.slug} />} />
          ))}
          <Route path="/track" element={<TrackPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </LanguageProvider>
  );
}
